import React from "react";
import styles from '../styles.module.scss';
import TickSvg from "../../../components/svg/TickSvg";
import Try, {TryBtn} from "../../../components/Try";

export default function SolutionsC() {
  return <>
    <section className={styles.head}>
      <div className={styles.headContent}>
        <div className={styles.title}>
          <h4>科创金融业务是金融机构发展的必然选择</h4>
          <h1>银行科创金融<br />解决方案</h1>
          <Try />
        </div>
        <div className={styles.sticker} style={{marginLeft: "86px"}}><img src="./static-official/images/sticker-s-c.png" height={442} style={{bottom: "80px"}} alt="私募股权投资" /></div>
      </div>
    </section>
    <section className={styles.commonSection0}>
      <div className={styles.detailContainer}>
        <div className={styles.detailBlock} style={{width: "385px"}}>
          <h3>科创金融综合解决方案</h3>
          <desc>利用全面丰富的科创企业数据与烯牛特色LP-GP-企业数据链条，为银行科创业务的商机拓客、企业尽调、风险监控等环节提供数据与模型支持。</desc>
          <ul>
            <li><h4><TickSvg />科创企业业务详情与标签画像</h4></li>
            <li><h4><TickSvg />科创企业评分模型</h4></li>
            <li><h4><TickSvg />私募股权基金托管线索</h4></li>
            <li><h4><TickSvg />私募股权生态增值工具（一键GP推荐等）</h4></li>
          </ul>
          <TryBtn />
        </div>
        <img src="./static-official/images/s-c.png" alt="科创金融综合解决方案" height={468}/>
      </div>
    </section>
  </>
}
